import cx from 'clsx';
// components
import { Box, Modal } from '@mui/material';
import { Button, colors, Icons, theme } from '../../../../packages';
// styles
import { useStyles } from './Modal.styles';

const UpdatesModal = ({
  open,
  title,
  icon,
  confirmText = 'Confirm',
  onClose,
  onConfirm,
  children,
  className = '',
}) => {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.root}>
        <Box
          sx={{
            position: 'relative',
            width: { sm: '480px', xs: 'auto' },
            padding: { sm: '40px 30px', xs: `40px 24px` },
            background: theme.palette.background.default,
            borderRadius: '10px',
          }}
          className={cx({ [className]: true })}
        >
          {icon && (
            <div className={classes.iconWrapper}>
              <Icons glyph={icon} className={classes.icon} />
            </div>
          )}
          <div className={classes.header}>
            <div className={classes.title}>{title}</div>
            <Icons glyph="close" onClick={onClose} className={classes.closeBtn} color={colors.neutral400} />
          </div>
          <div className={classes.content}>
            <div>{children}</div>

            <div className={classes.actions}>
              {onConfirm && (
                <Button sx={{ width: '100%' }} onClick={onConfirm}>
                  {confirmText}
                </Button>
              )}
            </div>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export { UpdatesModal };
